import apiFetch from '@wordpress/api-fetch'

let treatment = '?treatment=all'
let type = '&type=all'
let city = '&city=all'
let page = '&page=1'
let sort = '&order=asc'

/* eslint-disable */
;(function ($) {
	//hide and show filters on mobile
	if ($(window).width() < 1024) {
		$('.quicklinks-clear').text('Clear')
		$('.locations-filters-container').hide()
		$('.hide-filters').hide()
		$('.locations-results-show-hide-filters').css('display', 'flex')
	}

	$('.show-filters').on('click', function () {
		$(this).hide(0, function () {
			$('.locations-filters-container').slideToggle()
			$('.hide-filters').show()
		})
	})

	$('.hide-filters').on('click', function () {
		$('.locations-filters-container').slideToggle('slow', function () {
			$('.hide-filters').hide(0, function () {
				$('.show-filters').show()
			})
		})
	})

	//filter selections hide and show - treatments and services
	$('#treatments-hidden').hide()

	$('#show-more-treatments').on('click', function () {
		$(this).hide(0, function () {
			$('#treatments-hidden').slideToggle()
		})
	})

	$('#show-less-treatments').on('click', function () {
		$('#treatments-hidden').slideToggle('slow', function () {
			$('#show-more-treatments').show()
		})
	})

	//filter selections hide and show - location names
	$('#locations-hidden').hide()

	$('.clear-button').hide()

	$('#show-more-locations').on('click', function () {
		$(this).hide(0, function () {
			$('#locations-hidden').slideToggle()
		})
	})

	$('#show-less-locations').on('click', function () {
		$('#locations-hidden').slideToggle('slow', function () {
			$('#show-more-locations').show()
		})
	})

	//search select - this might be temporary
	$('.quicklinks-clear').hide()

	$('#locations-select').on('change', function () {
		switch (this.value) {
			case 'emergency-room':
				clearAllFilters()
				$('.quicklinks-clear').show()
				$('#emergency-room').prop('checked', true).trigger('change')
				break
			case 'find-a-physician':
				window.open('https://findadoc.umchealthsystem.com/search?sort=name')
				break
			case 'radiology-imaging':
				clearAllFilters()
				$('.quicklinks-clear').show()
				$('#radiology-imaging').prop('checked', true).trigger('change')
				break
			case 'pediatric-care':
				clearAllFilters()
				$('.quicklinks-clear').show()
				$('#pediatric-care').prop('checked', true).trigger('change')
				break
			case 'pharmacy':
				clearAllFilters()
				$('.quicklinks-clear').show()
				$('#pharmacy').prop('checked', true).trigger('change')
				break
			case 'primary-care':
				clearAllFilters()
				$('.quicklinks-clear').show()
				$('#primary-care').prop('checked', true).trigger('change')
				break
			case 'urgent-care':
				clearAllFilters()
				$('.quicklinks-clear').show()
				$('#urgent-care').prop('checked', true).trigger('change')
				break
			default:
			// code block
		}
	})

	//handle filtering
	$('input[name=treatment_service]').change(function () {
		page = '&page=1'
		treatment = '?treatment=' + $(this).val()
		history.pushState(null, null, treatment + type + city + sort + page)

		$('input[name="location"]').prop('checked', false)
		$('.name-filter .clear-button').hide()

		if ($('input[name="treatment_service"]:checked').val() !== $('#locations-select').val()) {
			$('#locations-select').prop('selectedIndex', 0) //reset quick links select
		}
		$('.treatments-filter .clear-button').show()

		check_url()
	})

	$('input[name=type]').change(function () {
		page = '&page=1'
		type = '&type=' + $(this).val()
		history.pushState(null, null, treatment + type + city + sort + page)

		$('input[name="location"]').prop('checked', false)
		$('.name-filter .clear-button').hide()

		if ($('input[name="type"]:checked').val() !== $('#locations-select').val()) {
			$('#locations-select').prop('selectedIndex', 0) //reset quick links select
		}
		$('.type-filter .clear-button').show()

		check_url()
	})

	$('input[name=city]').change(function () {
		page = '&page=1'
		city = '&city=' + $(this).val()
		history.pushState(null, null, treatment + type + city + sort + page)

		$('input[name="location"]').prop('checked', false)
		$('.name-filter .clear-button').hide()
		$('.city-filter .clear-button').show()

		check_url()
	})

	$('input[name=location]').change(function () {
		history.pushState(null, null, '?location=' + $(this).val() + sort)
		clearAllFilters()
		$('.name-filter .clear-button').show()
		$('#locations-select').prop('selectedIndex', 0) //reset quick links select

		check_url()
	})

	//handle sorting
	$('.umc-locations-container').on('click', '.locations-results-sort-desc', function () {
		sort = '&order=desc'
		history.pushState(null, null, treatment + type + city + sort + page)
		check_url()
	})

	$('.umc-locations-container').on('click', '.locations-results-sort-asc', function () {
		sort = '&order=asc'
		history.pushState(null, null, treatment + type + city + sort + page)
		check_url()
	})

	//handle filter clearing

	//clear quicklinks selection
	$('.locations-results-search-terms').on('click', '.quicklinks-clear', function () {
		$(this).hide()
		$('#locations-select').prop('selectedIndex', 0)
		$('input[name="treatment_service"]').prop('checked', false)
		$('input[name="location"]').prop('checked', false)
		$('input[name="type"]').prop('checked', false)
		treatment = '?treatment=all'
		type = '&type=all'
		page = '&page=1'
		history.pushState(null, null, treatment + type + city + sort + page)
		check_url()
	})

	$('#clear-treatments').on('click', function () {
		$(this).hide()
		$('#locations-select').prop('selectedIndex', 0)
		$('input[name="treatment_service"]').prop('checked', false)
		treatment = '?treatment=all'
		page = '&page=1'
		history.pushState(null, null, treatment + type + city + sort + page)
		check_url()
	})

	$('#clear-locationtype').on('click', function () {
		$(this).hide()
		$('#locations-select').prop('selectedIndex', 0)
		$('input[name="type"]').prop('checked', false)
		type = '&type=all'
		page = '&page=1'
		history.pushState(null, null, treatment + type + city + sort + page)
		check_url()
	})

	$('#clear-locationname').on('click', function () {
		$(this).hide()
		$('#locations-select').prop('selectedIndex', 0)
		$('input[name="location"]').prop('checked', false)
		history.pushState(null, null, treatment + type + city + sort + page)
		check_url()
	})

	$('#clear-city').on('click', function () {
		$(this).hide()
		$('#locations-select').prop('selectedIndex', 0)
		$('input[name="city"]').prop('checked', false)
		city = '&city=all'
		page = '&page=1'
		history.pushState(null, null, treatment + type + city + sort + page)
		check_url()
	})

	//on page load, check url and get data
	check_url()
})(jQuery)

function check_url() {
	var selectedTreatment = getUrlVars()['treatment']
	var selectedType = getUrlVars()['type']
	var selectedCity = getUrlVars()['city']
	var sortOrder = getUrlVars()['order'] || 'asc'
	var pageNumber = getUrlVars()['page'] || 1

	if (selectedTreatment || selectedType || selectedCity) {
		if (selectedTreatment && $('#' + selectedTreatment).length && selectedTreatment !== 'all') {
			treatment = '?treatment=' + selectedTreatment
			$('#' + selectedTreatment).prop('checked', true)
			$('.treatments-filter .clear-button').show()
			var containerDivId = $('#' + selectedTreatment)
				.parent()
				.parent()
				.attr('id')
			//console.log('containerDivId? ', containerDivId)
			if (containerDivId == 'treatments-hidden' && $('#treatments-hidden').is(':hidden')) {
				$('#show-more-treatments').hide(0, function () {
					$('#treatments-hidden').show()
					$('.hide-filters').show()
				})
			}
		}

		if (selectedType && $('#' + selectedType).length && selectedType !== 'all') {
			type = '&type=' + selectedType
			$('#' + selectedType).prop('checked', true)
			$('.type-filter .clear-button').show()
		}

		if (selectedCity && $('#' + selectedCity).length && selectedCity !== 'all') {
			city = '&city=' + selectedCity
			$('#' + selectedCity).prop('checked', true)
			$('.city-filter .clear-button').show()
		}

		umc_load_locations(pageNumber, sortOrder)
	} else {
		// Load page 1 as the default
		umc_load_locations(1, sortOrder)
	}
}

function umc_load_locations(page, order) {
	const treatment = $('input[name="treatment_service"]:checked').val() || null
	const location_name = $('input[name="location"]:checked').val() || null
	const location_type = $('input[name="type"]:checked').val() || null
	const city = $('input[name="city"]:checked').val() || null

	let treatmentParam = '',
		nameParam = '',
		typeParam = '',
		cityParam = '',
		orderParam = order ? order : 'asc'

	if (treatment) {
		treatmentParam = `&treatment=${treatment}`
	}

	if (city) {
		cityParam = `&city=${city}`
	}

	if (location_type) {
		typeParam = `&type=${location_type}`
	}

	if (location_name) {
		nameParam = `&name=${location_name}`
	}

	//https://stackoverflow.com/questions/72013005/create-pagination-for-a-wordpress-rest-api-request
	let totalPages = 0
	let totalPosts = 0
	let perPage = 8
	let pageCountText = 'Results'

	let restURL =
		locationsData.root_url +
		`/wp-json/wp/v2/locations?_embed${treatmentParam}${nameParam}${typeParam}${cityParam}&orderby=title&order=${orderParam}&per_page=${perPage}&page=${page}`

	$('.umc-locations-container').html(
		'<div class="loader-container"><div class="loader"><div class="double-bounce1"></div><div class="double-bounce2"></div></div></div>'
	)

	if ($(window).width() >= 1024) {
		$('html, body').animate({ scrollTop: 0 }, 'slow')
	}

	apiFetch({ path: restURL, parse: false })
		.then(async response => {
			totalPages = response.headers.get('x-wp-totalpages')
			totalPosts = response.headers.get('x-wp-total')

			if (totalPosts == 1) {
				pageCountText = 'Result'
			}

			let locationData = await response.json() // get json

			if (!locationData.length) {
				return (document.querySelector('#content').innerHTML = `<p>There are no results for your search.</p>`)
			}

			let sortOutput = `
			<p class="locations-results locations-results-sort"><span class="locations-results-sort-asc ${
				order == 'asc' ? 'locations-results-sort-active' : ''
			}">A-Z</span> | <span class="locations-results-sort-desc ${
				order == 'desc' ? 'locations-results-sort-active' : ''
			}">Z-A</span></p>`

			//don't show sorting if user has selected a location name filter, as there will only be one result - the selected location
			if (location_name) {
				sortOutput = ''
			}

			document.querySelector('#content').innerHTML = `
				<div class="locations-results-meta">
					<p class="locations-results locations-results-count">${totalPosts} ${pageCountText} Found</p>
					${sortOutput}
				</div>
			`
			locationData.forEach(data => {
				const photo = data._embedded['wp:featuredmedia']
					? `<div class="location-result-info-thumbnail"><img src="${data._embedded['wp:featuredmedia']['0'].source_url}" alt="${data.title.rendered}"></div>`
					: ''
				const streetline2 = data.acf.street_line_2 ? `${data.acf.street_line_2} <br>` : ''
				const phoneButton = data.acf.phone
					? `<span class="umc-location-button"><a href="tel:${data.acf.phone}" target="_blank"><i class="fas fa-phone"></i>${data.acf.phone}</a></span>`
					: ''
				let cleanStreetLine2 = streetline2 ? streetline2.replace(/<[^>]*>?/gm, ' ').trim() : ''
				document.querySelector('#content').innerHTML += `
					<div class="location-result">
						<div class="location-result-info-wrapper">
							<div class="location-result-info">
								${photo}
								<div class="location-result-info-content">
									<h2><a href="${data.link}">${data.title.rendered}</a></h2>
									<p><a href="${data.acf.google_maps_location}" target="_blank" rel="noopener" aria-label="Map of ${
					data.title.rendered
				} at ${data.acf.street} ${cleanStreetLine2}, ${data.acf.city}, ${data.acf.state} ${data.acf.zip}" >${
					data.acf.street
				}<br>
									${streetline2}${data.acf.city} ${data.acf.state} ${data.acf.zip}</a><br><span style="font-weight: 600;">Hours:</span> ${
					data.acf.hours_human_readable
				}${
					data.acf.drive_thru_hours
						? `<br><span style="font-weight: 600;">Drive-Thru Hours:</span> ${data.acf.drive_thru_hours}`
						: ''
				}</p>
								</div>
							</div>
							<div class="location-result-info-buttons">
								${phoneButton}
							</div>
						</div>
						<div class="location-result-footer">
							<hr>
							<div class="location-result-footer-info">
								<span><a href="${data.link}" aria-label="More Info About ${
					data.title.rendered
				}"><i class="fal fa-info-circle"></i> More Info</a> </span>
								<span><a href="${data.acf.google_maps_location}" target="_blank" rel="noopener" aria-label="Driving Directions to ${
					data.title.rendered
				}"><i class="fal fa-car"></i> Driving Directions</a> </span>
							</div>
						</div>
					</div>
				`
			})
			document.querySelector('#content').innerHTML += `<nav class="locations-pagination"></div>`

			if (totalPages > 1) {
				createPagination(totalPages, page, order)
			}
		})
		.catch(err => {
			console.log(err)
			let message = err.statusText || 'Sorry, we were unable to load the data for your request.'
			document.querySelector('#content').innerHTML = `<p>Error ${err.status}: ${message}</p>`
			//$loader.style.display = 'none'
		})
}

function createPagination(totalPages, currentPage) {
	document.querySelector('.locations-pagination').innerHTML += `<ul id="pagination"></ul>`
	for (var i = 0; i < totalPages; i++) {
		let li = document.createElement('li')
		if (i + 1 == currentPage) {
			li.classList.add('selected')
		} else {
			li.classList.add('active')
			li.onclick = function () {
				page = '&page=' + this.textContent
				history.pushState(null, null, treatment + type + city + sort + page)

				check_url()
			}
		}
		li.textContent = i + 1

		document.querySelector('#pagination').appendChild(li)
	}
}

// check to see if there is query string in the URL
// for testing - simulate a "window.location.search" string.
// inspiration from https://stackoverflow.com/questions/4656843/get-querystring-from-url-using-jquery
// var testurl = "?treatment=cancer-care";
function getUrlVars() {
	var vars = [],
		hash
	var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&')
	//var hashes = testurl.slice(testurl.indexOf('?') + 1).split('&');
	for (var i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=')
		vars.push(hash[0])
		vars[hash[0]] = hash[1]
	}
	return vars
}

function clearAllFilters() {
	$('input[name="treatment_service"], input[name="type"], input[name="city"], input[name="name"]').prop(
		'checked',
		false
	)
	treatment = '?treatment=all'
	type = '&type=all'
	city = '&city=all'
	page = '&page=1'
	$('.clear-button').hide()
}
